export default __webpack_public_path__ + "static/46-e69a6adb7e2aada0c7db35a44a75e1b6.png";